export const Benefit = (props) => {
  return (
    <div id="benefit">
      <div className="container">
        <div className="row">
          <div className="">
            <div className="benefit-text">
              {" "}
              <br />
              <br />
              <br />
              <br />
              <br />
              {/* <h2>Call To Action</h2> */}
              <h2>Benefits from Cyclo</h2>
              <h4>Here are the benefit that we provide:</h4>
              <div className="list-style">
                <div className="">
                  <ul>
                    {props.data
                      ? props.data.benefit.map((d, i) => (
                          <li
                            style={{ fontWeight: "bolder" }}
                            key={`${d}-${i}`}
                          >
                            {d}
                          </li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
              <br />
              <h4>Why you should choose us over the competitors:</h4>
              <div className="list-style">
                <div className="">
                  <ul>
                    {props.data
                      ? props.data.why.map((d, i) => (
                          <li
                            style={{ fontWeight: "bolder" }}
                            key={`${d}-${i}`}
                          >
                            {d}
                          </li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
